import { OccupantAddress, UserAddress } from '@centecomm/portal-service';
import { Address } from '../State/Shared/Types/Address';

const formatCityAndState = (address: OccupantAddress | UserAddress | Address): string => {
    const { city = '', state = '' } = address;

    const hasCity = (): boolean => !!city && city.length > 0;
    const hasState = (): boolean => !!state && state.length > 0;

    if (hasCity() && hasState()) return `${city}, ${state}`;

    if (!!city && hasCity() && !hasState()) return city;

    if (!hasCity() && !!state && hasState()) return state;

    return '';
};

export default formatCityAndState;
